<div>
  <form (ngSubmit)="this.submitForm($event)" *transloco="let transloco" [formGroup]="this.form">
    <div>
      <formly-form
        [fields]="this.fields"
        [form]="this.form"
        [model]="this.model"
        [options]="this.options!"></formly-form>
      <ng-content select="[beforeSubmit]"></ng-content>
      <div class="mt-4 flex space-x-2">
        <ng-content select="[submit]"></ng-content>
        @if (this.form.enabled) {
          @if (this.showSaveButton) {
            <p-button
              [icon]="this.saving ? 'pi pi-spin pi-spinner' : this.saveButtonIcon"
              [label]="transloco(this.saveButtonText)"
              [disabled]="this.saving"
              type="submit"></p-button>
          }
          @if (this.showCancelButton) {
            <p-button
              (click)="this.cancel()"
              [disabled]="this.saving"
              outlined
              severity="secondary"
              label="{{ transloco('cancel') }}"></p-button>
          }
        }
      </div>
      <ng-content select="[afterSubmit]"></ng-content>
    </div>
  </form>
  @if (this.isDevMode()) {
    <div class="mt-5">
      <p-button
        (click)="this.showDebug = !this.showDebug"
        outlined
        severity="secondary"
        label="Debug"></p-button>
      @if (this.showDebug) {
        <div>
          @if (this.form) {
            <pre
              class="mt-2 overflow-x-auto bg-gray-200 p-2"
              style="max-width: 100%; width: 0; min-width: 100%"
              >{{ this.form.getRawValue() | json }}</pre>
          }
        </div>
      }
    </div>
  }
</div>
